const selectCurrencyCodes = (state) => state.currencies.currencyCodes;
const selectCurrentCurrencyCode = (state) => state.currencies.currentCurrencyCode;

export { selectCurrencyCodes, selectCurrentCurrencyCode };
//# sourceMappingURL=currencies.js.map
